import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../../core/services/header.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {AuthService} from '../../../core/security/auth.service';
import {merge, Subscription} from 'rxjs';
import {RolesEnum} from '../../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {PbxAccountsService as PbxAccountsApiService} from '../../../api/services/pbx-accounts.service';
import {PbxAccountsDatasource} from './pbx-accounts.datasource';
import {HolidayGreetingsListRequest} from '../../../api/models/holiday-greetings-list-request';
import {NotificationService} from '../../../notification/notification.service';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { PhoneNumberPipe } from '../../../core/pipes/phone-number.pipe';
import { MacAddressPipe } from '../../../core/pipes/mac-address.pipe';

@Component({
    selector: 'app-pbx-accounts-grid',
    templateUrl: './pbx-accounts-grid.component.html',
    styleUrls: ['./pbx-accounts-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        RouterLink,
        NgFor,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
        MacAddressPipe,
    ],
})
export class PbxAccountsGridComponent implements OnDestroy, OnInit, AfterViewInit {
  displayedColumns: string[] = ['name', 'fullName', 'cellDis', 'emailAddress', 'mac'];
  @Input() filterChangeEvent: EventEmitter<void>;
  @Input() showAdditionalColumns = false;
  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  isLoading = false;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: PbxAccountsDatasource;
  authSubscription: Subscription;
  hasEditAccess: boolean;
  hasEditOwnAccess: boolean;
  userExtension = '';

  constructor(public dialog: MatDialog,
              private pbxApiService: PbxAccountsApiService,
              private notificationService: NotificationService,
              private route: ActivatedRoute, public headerService: HeaderService, public authService: AuthService) {
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.hasEditAccess = this.authService.hasAccess([
      RolesEnum.PbxAccounts_Edit,
      RolesEnum.PbxAccounts_Delete,
    ]);
    this.hasEditOwnAccess = this.authService.hasAccess([
      RolesEnum.PbxAccounts_EditOwn,
    ]);
    this.dataSource = new PbxAccountsDatasource(this.pbxApiService);

    this.authSubscription = this.authService.currentUser.subscribe((user) => {
      if (user) {
        this.userExtension = user.primaryExtension;
      } else {
        this.userExtension = '';
      }
    });
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): HolidayGreetingsListRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }
}
